<template>
  <div class="reportWrapper">
    <template v-if="jsonReady">
      <div class="report-component" id="tr-leading-indicators-html">
        <h4>{{ helpJsonContent.indicator_type.section_title }}</h4>

        <p v-html="helpJsonContent.indicator_type.body"></p>

        <div class="scrollable-image margin-top--quarter">
          <img
            :src="
              images_path +
              helpJsonContent.indicator_type.image1.attributes.href
            "
            alt="TR Indicator Types Report Image"
          />
        </div>

        <h4 class="margin-top">
          {{ helpJsonContent.indicator_type.section_title2 }}
        </h4>

        <p v-html="helpJsonContent.indicator_type.body2"></p>
      </div>
    </template>
  </div>
</template>

<script>
  import moment from 'moment';
  export default {
    props: {
      content: {
        type: String,
        required: false,
      },
      imagespath: {
        type: String,
        required: false,
      },
      issue: {
        type: String,
        required: false,
      },
      fromTr: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: function () {
      return {
        parsed: {},
        jsonReady: true,
        summary: '',
        images_path: this.imagespath,
      };
    },
    computed: {
      helpJsonContent: function () {
        return JSON.parse(this.content);
      },
    },
    methods: {
      momentFormat(date, format) {
        return moment(date).format(format);
      },
      parseJson: function () {
        this.jsonReady = true;
      },

      convertToHyphens: function (value) {
        return value.replace(/_/g, '-');
      },
    },
  };
  //https://stackoverflow.com/questions/13869627/unable-to-access-json-property-with-dash  jsonObj.profile - id
  //To access a key that contains characters that cannot appear in an identifier, use brackets: jsonObj["profile-id"]
</script>
